/* Farmacy For Life redesign — namespaced, idempotent, theme-editor aware. */
(function(){
  if (window.FFL && window.FFL.__init) { window.FFL.boot(); return; }
  var FFL = window.FFL = window.FFL || {};
  FFL.__init = true;

  function countdown(el){
    if (el.__ffl) return; el.__ffl = true;
    var end = parseInt(el.getAttribute('data-ffl-end'), 10);
    if (!end || isNaN(end)) return;
    var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    function pad(n){ return (n<10?'0':'')+n; }
    function tick(){
      var diff = Math.max(0, end - Math.floor(Date.now()/1000));
      var dd = Math.floor(diff/86400), hh = Math.floor((diff%86400)/3600), mm = Math.floor((diff%3600)/60), ss = diff%60;
      if (d) d.textContent = pad(dd); if (h) h.textContent = pad(hh); if (m) m.textContent = pad(mm); if (s) s.textContent = pad(ss);
    }
    tick(); var t = setInterval(tick, 1000); el.__fflTimer = t;
  }

  function videoCard(card){
    if (card.__ffl) return; card.__ffl = true;
    var btn = card.querySelector('.ffl-vcard__ctrl');
    var vid = card.querySelector('video');
    if (!btn) return;
    btn.addEventListener('click', function(){
      var playing = card.classList.contains('is-playing');
      document.querySelectorAll('.ffl-vcard.is-playing').forEach(function(c){ c.classList.remove('is-playing'); var v=c.querySelector('video'); if(v){try{v.pause();}catch(e){}} });
      if (!playing){ card.classList.add('is-playing'); if(vid){ try{ vid.play(); }catch(e){} } }
    });
  }

  FFL.boot = function(root){
    root = root || document;
    root.querySelectorAll('.ffl-countdown[data-ffl-end]').forEach(countdown);
    root.querySelectorAll('.ffl-vcard').forEach(videoCard);
  };

  if (document.readyState !== 'loading') FFL.boot(); else document.addEventListener('DOMContentLoaded', function(){ FFL.boot(); });
  document.addEventListener('shopify:section:load', function(e){ FFL.boot(e.target); });
})();
